import { render, staticRenderFns } from "./matches.vue?vue&type=template&id=d90c8df8&scoped=true&"
import script from "./matches.vue?vue&type=script&lang=js&"
export * from "./matches.vue?vue&type=script&lang=js&"
import style0 from "./matches.vue?vue&type=style&index=0&id=d90c8df8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d90c8df8",
  null
  
)

export default component.exports